exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ledger-outstanding-upload-container[data-v-65546dbf]{padding:10px}.upload-card[data-v-65546dbf]{position:relative}.loading-overlay[data-v-65546dbf]{position:absolute;top:0;left:0;right:0;bottom:0;background:hsla(0,0%,100%,.8);display:flex;align-items:center;justify-content:center;z-index:10}.table-responsive[data-v-65546dbf]{max-height:400px}.action-buttons[data-v-65546dbf]{border-top:1px solid #eee;padding-top:15px;margin-top:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-65546dbf","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/dashboard/LedgerOutstandingBulkUpload.vue
// module id = 1657
// module chunks = 0